import React, { useState } from "react";
import PropTypes from "prop-types";
import styles from "./CMSSectionElement.module.css";
import { IconPlay, IconView } from "@wwg/icons";
import { PureMediaModal } from "../MediaModal/MediaModal";

function resolveMediaSource(file) {
  const source =
    file.downloadPath ||
    file.DownloadPath ||
    file.url ||
    file.Url ||
    file.path ||
    file.Path ||
    "";

  if (!source) return "";
  if (/^https?:\/\//i.test(source)) return source;
  // Treat value as a Vzaar ID
  return `https://view.vzaar.com/${source}/player`;
}

/**
 * View component. Displays CMS item content for a feed item section.
 */
export function CMSSectionElement({ cmsItem }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [playingMedia, setPlayingMedia] = useState(null);

  const handleFileClick = (file) => {
    const playerPath = resolveMediaSource(file);
    const format = (file.format || "").toLowerCase();
    const toolType = format === "audio" ? 15 : 16;
    setPlayingMedia({ toolType, playerPath });
    setIsModalOpen(true);
  };

  return (
    <div className={styles.container}>
      {cmsItem === undefined || cmsItem === null ? (
        <h3 className={styles.text}> Content Not Found </h3>
      ) : (
        <div className={styles.cmsItem}>
          <div className={styles.title}>{cmsItem.title}</div>
          <div className={styles.mediaSection}>
            {(cmsItem.files || []).map((file, index) => (
              <span
                key={index}
                onClick={() => handleFileClick(file)}
                style={{ cursor: "pointer" }}
              >
                {(file.format || "").toLowerCase() === "video" ||
                (file.format || "").toLowerCase() === "audio" ? (
                  <IconPlay />
                ) : (
                  <IconView />
                )}
              </span>
            ))}
          </div>
        </div>
      )}
      {isModalOpen && playingMedia && (
        <PureMediaModal
          toggleMediaPlayer={() => setIsModalOpen(false)}
          showMediaPlayer={isModalOpen}
          playingMedia={playingMedia}
        />
      )}
    </div>
  );
}

CMSSectionElement.propTypes = {
  /**
   * CMS item content.
   */
  cmsItem: PropTypes.shape({
    title: PropTypes.string,
    files: PropTypes.arrayOf(
      PropTypes.shape({
        format: PropTypes.string,
        downloadPath: PropTypes.string,
        DownloadPath: PropTypes.string,
        url: PropTypes.string,
        Url: PropTypes.string,
        path: PropTypes.string,
        Path: PropTypes.string,
      })
    ),
  }),
};
